import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { KbReturnRequestFileService } from '../kb-returnRequestFile.service';

@Component({
  selector: 'app-return-request-file-upload',
  templateUrl: './return-request-file-upload.component.html',
  styleUrls: ['../kbreturnrequestform/kbreturnrequestform.component.scss'],
  standalone: false
})
export class ReturnRequestFileUploadComponent {
  isDuplicateFile: boolean = false;
  isMaxFileSize: boolean = false;
  isUploadfileSuccess: boolean = false;
  isAtleastOnefileIsThere: boolean = true;
  productNotFound = undefined;
  fileLength$: Observable<any> = this.fileService.getCurrentFileCount(this._data.id);
  fileCurrentFiles$: Observable<any> = this.fileService.getCurrentFilesInfo(this._data.id);
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any, private fileService: KbReturnRequestFileService) { }

  fileSelector(event: any) {
    const files = Object.values(event.files);
    const TotalFileSizeExceeds = this.fileService.isTotalFileSizeLessThan9MB(this._data.id);

    files.map((file: File) => {
      if (!this.fileService.isFileSizeLessThan9MB(file) || !TotalFileSizeExceeds) {
        this.isMaxFileSize = true;
      } else if (!this.fileService.isNotDuplicate(file.name, this._data.id)) {
        this.isDuplicateFile = true;
      } else {
        this.fileService.addFile(file, this._data.id, this._data.index);
        this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent(this._data.id);
      }
    });

    this.timeout = setTimeout(() => {
      this.isDuplicateFile = false;
      this.isMaxFileSize = false;
      this.isUploadfileSuccess = false;
    }, 7000);
  }
  removeFile(file: File) {
    this.fileService.deleteFile(file.name, this._data.id, this._data.index);
    this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent(this._data.id);
  }

  fileUploadFunction(index: number) {
    this.isAtleastOnefileIsThere = this.fileService.isAtLeastOneFilePresent(this._data.id);
    if (this.isAtleastOnefileIsThere) {
      this.isUploadfileSuccess = true;
    }
    this.timeout = setTimeout(() => {
      this.isUploadfileSuccess = false;
    }, 7000);
  }

  ngOnDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
